import { Component } from '@angular/core';

@Component({
  selector: 'app-due-diligence',
  templateUrl: './due-diligence.component.html',
  styleUrls: ['./due-diligence.component.css']
})
export class DueDiligenceComponent {
ShowCard:any;
}
